import { render, staticRenderFns } from "./NoticeItem.vue?vue&type=template&id=0b4f86be&scoped=true"
import script from "./NoticeItem.vue?vue&type=script&lang=js"
export * from "./NoticeItem.vue?vue&type=script&lang=js"
import style0 from "./NoticeItem.vue?vue&type=style&index=0&id=0b4f86be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f86be",
  null
  
)

export default component.exports